const DEFAULT_TREE_NAME = 'viveret';
const LAST_LOADED_TREE_KEY = 'last_loaded_tree_name_v1';

/**
 * The full, fixed set of family trees this install serves. There is no
 * unauthenticated endpoint to list trees (GET /api/trees/ requires an admin
 * token), so a picker built before login - e.g. for choosing which tree a new
 * Google account should join - has to work off a maintained list like this
 * one rather than fetching it.
 *
 * `id` is the human-readable slug used for in-app routing (`/viveret`, etc.).
 * `uuid` is gramps-webapi's actual tree ID (its database dirname) - the value
 * `/api/oidc/login/?tree=` requires; passing the slug there 422s with "tree
 * does not exist". Looked up once per tree via `GET /api/users/` (each
 * project's own account row carries its tree's real ID in `tree`), since
 * `GET /api/trees/`, which would list this directly, needs an admin token.
 */
export const KNOWN_TREES: { id: string; uuid: string; label: string }[] = [
  { id: 'viveret', uuid: '6d7059fb-8faf-4d68-91a0-fdb4728fbcd1', label: 'Famille Viveret' },
  { id: 'petit', uuid: '24bdff6e-0b4e-4bbe-906d-16748ee7e2cf', label: 'Famille Petit' },
  { id: 'paucara', uuid: '3a745ce2-78f2-41f9-86cc-a789bf3442f1', label: 'Famille Paucara' },
  { id: 'ornella', uuid: '3886fdc1-2e63-42b2-afaa-0f1dd80d3e96', label: 'Famille Ornella' },
];

export function getLastLoadedTreeName(): string | null {
  const value = window.sessionStorage.getItem(LAST_LOADED_TREE_KEY);
  const trimmed = value?.trim();
  return trimmed && trimmed.length > 0 ? trimmed : null;
}

export function rememberLastLoadedTreeName(treeName?: string | null): void {
  const trimmed = treeName?.trim();
  if (!trimmed) {
    return;
  }
  window.sessionStorage.setItem(LAST_LOADED_TREE_KEY, trimmed);
}

export function getDefaultTreeName(): string {
  return getLastLoadedTreeName() || DEFAULT_TREE_NAME;
}
